import "./styles.scss";

const Header = () => (
  <nav className="bg-primary text-title">
      <h4>Incomplete Hippocampal Inversion Score</h4>
  </nav>
)

export default Header;